import template from './seniority-report.html';
import controller from './seniority-report.controller';

let seniorityReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default seniorityReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/seniority-report/seniority-report.component.js